import MarqueeLib from "react-fast-marquee";
import { Flower2 } from "lucide-react";

const items = [
  "Handmade with love",
  "100% soft cotton yarn",
  "Cute & cozy",
  "Small batch stitches",
  "Crafted slowly",
];

const Marquee = () => (
  <div
    className="bg-[#E8EAE3] border-y border-[#D3D7CF] py-5 -rotate-1 scale-[1.02] my-4"
    data-testid="editorial-marquee"
  >
    <MarqueeLib speed={28} gradient={false}>
      {items.map((item) => (
        <span
          key={item}
          className="flex items-center gap-6 mx-8 font-heading font-medium text-[#8AA387] text-lg uppercase tracking-[0.2em]"
        >
          {item}
          <Flower2 size={18} className="text-[#C27F67]" />
        </span>
      ))}
    </MarqueeLib>
  </div>
);

export default Marquee;
